/** @format */

import React from "react";

const comonIcons = {
  info: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>6AB99C0B-0DAC-41B6-B748-720E6DDEBA3A</title>
      <g
        id="Admin-account"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
        opacity="0.5"
      >
        <g id="Admin-Dashboard" transform="translate(-32.000000, -543.000000)">
          <g id="Side-Menu" transform="translate(0.000000, 70.000000)">
            <g id="Info" transform="translate(0.000000, 462.000000)">
              <g
                id="person-24px-(2)"
                transform="translate(32.000000, 11.000000)"
              >
                <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                <path
                  d="M12,12 C14.21,12 16,10.21 16,8 C16,5.79 14.21,4 12,4 C9.79,4 8,5.79 8,8 C8,10.21 9.79,12 12,12 Z M12,14 C9.33,14 4,15.34 4,18 L4,19 C4,19.55 4.45,20 5,20 L19,20 C19.55,20 20,19.55 20,19 L20,18 C20,15.34 14.67,14 12,14 Z"
                  id="Shape"
                  fill="#000000"
                  fill-rule="nonzero"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  gym: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Admin-account"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
        opacity="0.5"
      >
        <g id="Admin-Dashboard" transform="translate(-32.000000, -594.000000)">
          <g id="Side-Menu" transform="translate(0.000000, 70.000000)">
            <g id="Gyms" transform="translate(0.000000, 513.000000)">
              <g
                id="fitness_center-24px"
                transform="translate(32.000000, 11.000000)"
              >
                <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                <path
                  d="M20.57,14.86 L21.29,14.14 C21.68,13.75 21.68,13.12 21.29,12.73 L21.27,12.71 C20.88,12.32 20.25,12.32 19.86,12.71 L17,15.57 L8.43,7 L11.29,4.14 C11.68,3.75 11.68,3.12 11.29,2.73 L11.27,2.71 C10.88,2.32 10.25,2.32 9.86,2.71 L9.14,3.43 L8.42,2.71 C8.03,2.32 7.39,2.32 7,2.71 L5.57,4.14 L4.85,3.42 C4.46,3.03 3.81,3.03 3.42,3.42 C3.03,3.81 3.03,4.46 3.42,4.85 L4.14,5.57 L2.71,7 C2.32,7.39 2.32,8.02 2.71,8.41 L3.43,9.13 L2.71,9.86 C2.32,10.25 2.32,10.88 2.71,11.27 L2.73,11.29 C3.12,11.68 3.75,11.68 4.14,11.29 L7,8.43 L15.57,17 L12.71,19.86 C12.32,20.25 12.32,20.88 12.71,21.27 L12.73,21.29 C13.12,21.68 13.75,21.68 14.14,21.29 L14.86,20.57 L15.58,21.29 C15.97,21.68 16.6,21.68 16.99,21.29 L18.42,19.86 L19.14,20.58 C19.53,20.97 20.18,20.97 20.57,20.58 C20.96,20.19 20.96,19.54 20.57,19.15 L19.85,18.43 L21.29,17 C21.68,16.61 21.68,15.98 21.29,15.59 L20.57,14.86 Z"
                  id="Path"
                  fill="#000000"
                  fill-rule="nonzero"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  trainer: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Admin-account"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
        opacity="0.5"
      >
        <g id="Admin-Dashboard" transform="translate(-32.000000, -648.000000)">
          <g id="Side-Menu" transform="translate(0.000000, 70.000000)">
            <g id="Trainers" transform="translate(0.000000, 567.000000)">
              <g
                id="self_improvement-24px"
                transform="translate(32.000000, 11.000000)"
              >
                <g id="Group">
                  <rect
                    id="Rectangle"
                    x="0"
                    y="0"
                    width="24"
                    height="24"
                  ></rect>
                  <rect
                    id="Rectangle"
                    x="0"
                    y="0"
                    width="24"
                    height="24"
                  ></rect>
                </g>
                <g
                  id="Group"
                  transform="translate(3.000000, 4.000000)"
                  fill="#000000"
                  fill-rule="nonzero"
                >
                  <circle id="Oval" cx="9" cy="2" r="2"></circle>
                  <path
                    d="M18,10.94 L18,10.94 C18,10.44 17.64,10.01 17.15,9.96 C15.27,9.75 13.66,8.83 12.4,7.33 L11.06,5.73 C10.68,5.26 10.12,5 9.53,5 L8.48,5 C7.89,5 7.33,5.26 6.95,5.72 L5.61,7.32 C4.36,8.82 2.74,9.74 0.86,9.95 C0.36,10.01 0,10.44 0,10.94 L0,10.94 C0,11.54 0.53,12.01 1.13,11.94 C3.43,11.67 5.45,10.55 7,8.75 L7,11 L3.24,12.5 C2.59,12.76 2.08,13.33 2.01,14.03 C1.91,15.1 2.74,16 3.79,16 L6,16 L6,15.5 C6,14.12 7.12,13 8.5,13 L11.5,13 C11.78,13 12,13.22 12,13.5 C12,13.78 11.78,14 11.5,14 L8.5,14 C7.67,14 7,14.67 7,15.5 L7,16 L14.1,16 C14.95,16 15.75,15.46 15.95,14.63 C16.16,13.74 15.68,12.87 14.87,12.55 L11,11 L11,8.75 C12.56,10.55 14.57,11.66 16.87,11.94 C17.47,12 18,11.54 18,10.94 Z"
                    id="Path"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  terms: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Admin-account"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
        opacity="0.5"
      >
        <g id="Admin-Dashboard" transform="translate(-32.000000, -702.000000)">
          <g id="Side-Menu" transform="translate(0.000000, 70.000000)">
            <g id="Trainers" transform="translate(0.000000, 621.000000)">
              <g
                id="description-24px"
                transform="translate(32.000000, 11.000000)"
              >
                <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                <path
                  d="M14.59,2.59 C14.21,2.21 13.7,2 13.17,2 L6,2 C4.9,2 4,2.9 4,4 L4,20 C4,21.1 4.89,22 5.99,22 L18,22 C19.1,22 20,21.1 20,20 L20,8.83 C20,8.3 19.79,7.79 19.41,7.42 L14.59,2.59 Z M15,18 L9,18 C8.45,18 8,17.55 8,17 C8,16.45 8.45,16 9,16 L15,16 C15.55,16 16,16.45 16,17 C16,17.55 15.55,18 15,18 Z M15,14 L9,14 C8.45,14 8,13.55 8,13 C8,12.45 8.45,12 9,12 L15,12 C15.55,12 16,12.45 16,13 C16,13.55 15.55,14 15,14 Z M13,8 L13,3.5 L18.5,9 L14,9 C13.45,9 13,8.55 13,8 Z"
                  id="Shape"
                  fill="#000000"
                  fill-rule="nonzero"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  privacy: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Admin-account"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
        opacity="0.5"
      >
        <g id="Admin-Dashboard" transform="translate(-32.000000, -756.000000)">
          <g id="Side-Menu" transform="translate(0.000000, 70.000000)">
            <g id="Users" transform="translate(0.000000, 675.000000)">
              <g
                id="privacy_tip-24px"
                transform="translate(32.000000, 11.000000)"
              >
                <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
                <path
                  d="M4.19,4.47 C3.47,4.79 3,5.51 3,6.3 L3,11 C3,16.55 6.84,21.74 12,23 C17.16,21.74 21,16.55 21,11 L21,6.3 C21,5.51 20.53,4.79 19.81,4.47 L12.81,1.36 C12.29,1.13 11.7,1.13 11.19,1.36 L4.19,4.47 Z M12,7 L12,7 C12.55,7 13,7.45 13,8 L13,8 C13,8.55 12.55,9 12,9 L12,9 C11.45,9 11,8.55 11,8 L11,8 C11,7.45 11.45,7 12,7 Z M12,11 L12,11 C12.55,11 13,11.45 13,12 L13,16 C13,16.55 12.55,17 12,17 L12,17 C11.45,17 11,16.55 11,16 L11,12 C11,11.45 11.45,11 12,11 Z"
                  id="Shape"
                  fill="#000000"
                  fill-rule="nonzero"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  mailtemplate: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Admin-account"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
        opacity="0.5"
      >
        <g id="Admin-Dashboard" transform="translate(-32.000000, -810.000000)">
          <g id="Side-Menu" transform="translate(0.000000, 70.000000)">
            <g
              id="Manage-EMail-Templates"
              transform="translate(0.000000, 729.000000)"
            >
              <g
                id="all_inbox-24px"
                transform="translate(32.000000, 11.000000)"
              >
                <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                <path
                  d="M19,3 L5,3 C3.9,3 3,3.9 3,5 L3,12 C3,13.1 3.9,14 5,14 L19,14 C20.1,14 21,13.1 21,12 L21,5 C21,3.9 20.1,3 19,3 Z M19,9 L15.86,9 C15.39,9 15.02,9.33 14.89,9.78 C14.53,11.04 13.35,12 12,12 C10.65,12 9.47,11.04 9.11,9.78 C8.98,9.33 8.61,9 8.14,9 L5,9 L5,6 C5,5.45 5.45,5 6,5 L18,5 C18.55,5 19,5.45 19,6 L19,9 Z M15.87,16 L20,16 C20.55,16 21,16.45 21,17 L21,19 C21,20.1 20.1,21 19,21 L5,21 C3.9,21 3,20.1 3,19 L3,17 C3,16.45 3.45,16 4,16 L8.13,16 C8.6,16 8.98,16.34 9.11,16.8 C9.46,18.07 10.62,19 12,19 C13.38,19 14.54,18.07 14.89,16.8 C15.02,16.34 15.4,16 15.87,16 Z"
                  id="Shape"
                  fill="#000000"
                  fill-rule="nonzero"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  social: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Admin-account"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
        opacity="0.5"
      >
        <g id="Admin-Dashboard" transform="translate(-32.000000, -864.000000)">
          <g id="Side-Menu" transform="translate(0.000000, 70.000000)">
            <g id="Social-media" transform="translate(0.000000, 783.000000)">
              <g id="share-24px" transform="translate(32.000000, 11.000000)">
                <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                <path
                  d="M18,16.08 C17.24,16.08 16.56,16.38 16.04,16.85 L8.91,12.7 C8.96,12.47 9,12.24 9,12 C9,11.76 8.96,11.53 8.91,11.3 L15.96,7.19 C16.5,7.69 17.21,8 18,8 C19.66,8 21,6.66 21,5 C21,3.34 19.66,2 18,2 C16.34,2 15,3.34 15,5 C15,5.24 15.04,5.47 15.09,5.7 L8.04,9.81 C7.5,9.31 6.79,9 6,9 C4.34,9 3,10.34 3,12 C3,13.66 4.34,15 6,15 C6.79,15 7.5,14.69 8.04,14.19 L15.16,18.35 C15.11,18.56 15.08,18.78 15.08,19 C15.08,20.61 16.39,21.92 18,21.92 C19.61,21.92 20.92,20.61 20.92,19 C20.92,17.39 19.61,16.08 18,16.08 Z"
                  id="Path"
                  fill="#000000"
                  fill-rule="nonzero"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  admin: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Admin-account"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
        opacity="0.5"
      >
        <g id="Gym-Info" transform="translate(-32.000000, -836.000000)">
          <g id="Social-media" transform="translate(0.000000, 825.000000)">
            <g
              id="admin_panel_settings-24px"
              transform="translate(32.000000, 11.000000)"
            >
              <g id="Group">
                <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
                <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
              </g>
              <g
                id="Group"
                transform="translate(3.000000, 3.000000)"
                fill="#000000"
                fill-rule="nonzero"
              >
                <path
                  d="M14,8 C14.34,8 14.67,8.04 15,8.09 L15,4.58 C15,3.78 14.53,3.06 13.8,2.75 L8.3,0.35 C7.79,0.13 7.21,0.13 6.7,0.35 L1.2,2.75 C0.47,3.07 0,3.79 0,4.58 L0,8.18 C0,12.72 3.2,16.97 7.5,18 C8.05,17.87 8.58,17.68 9.1,17.45 C8.41,16.47 8,15.28 8,14 C8,10.69 10.69,8 14,8 Z"
                  id="Path"
                ></path>
                <path
                  d="M14,10 C11.79,10 10,11.79 10,14 C10,16.21 11.79,18 14,18 C16.21,18 18,16.21 18,14 C18,11.79 16.21,10 14,10 Z M14,11.38 C14.62,11.38 15.12,11.89 15.12,12.5 C15.12,13.11 14.61,13.62 14,13.62 C13.39,13.62 12.88,13.11 12.88,12.5 C12.88,11.89 13.38,11.38 14,11.38 Z M14,16.75 C13.07,16.75 12.26,16.29 11.76,15.58 C11.81,14.86 13.27,14.5 14,14.5 C14.73,14.5 16.19,14.86 16.24,15.58 C15.74,16.29 14.93,16.75 14,16.75 Z"
                  id="Shape"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  accounting: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Admin-account"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
        opacity="0.5"
      >
        <g
          id="Editing-Super-Admin-Info"
          transform="translate(-32.000000, -836.000000)"
        >
          <g id="Accounting-Tab" transform="translate(0.000000, 825.000000)">
            <g
              id="card_membership-24px"
              transform="translate(32.000000, 11.000000)"
            >
              <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
              <path
                d="M20,2 L4,2 C2.89,2 2,2.89 2,4 L2,15 C2,16.11 2.89,17 4,17 L8,17 L8,22 L12,20 L16,22 L16,17 L20,17 C21.11,17 22,16.11 22,15 L22,4 C22,2.89 21.11,2 20,2 Z M20,15 L4,15 L4,13 L20,13 L20,15 Z M20,10 L4,10 L4,5 C4,4.45 4.45,4 5,4 L19,4 C19.55,4 20,4.45 20,5 L20,10 Z"
                id="Shape"
                fill="#000000"
                fill-rule="nonzero"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  excel: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Admin-account"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Exporting-Data" transform="translate(-1169.000000, -212.000000)">
          <g id="Excel" transform="translate(1169.000000, 212.000000)">
            <image id="Bitmap" x="2" y="3" width="20" height="18"></image>
            <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
          </g>
        </g>
      </g>
    </svg>
  ),
  pdf: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
    >
      <g
        id="Admin-account"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Exporting-Data" transform="translate(-1169.000000, -258.000000)">
          <g
            id="picture_as_pdf-24px"
            transform="translate(1169.000000, 258.000000)"
          >
            <polygon id="Path" points="0 0 24 0 24 24 0 24" />
            <path
              d="M20,2 L8,2 C6.9,2 6,2.9 6,4 L6,16 C6,17.1 6.9,18 8,18 L20,18 C21.1,18 22,17.1 22,16 L22,4 C22,2.9 21.1,2 20,2 Z M11.5,9.5 C11.5,10.33 10.83,11 10,11 L9,11 L9,13 L7.5,13 L7.5,7 L10,7 C10.83,7 11.5,7.67 11.5,8.5 L11.5,9.5 Z M16.5,11.5 C16.5,12.33 15.83,13 15,13 L12.5,13 L12.5,7 L15,7 C15.83,7 16.5,7.67 16.5,8.5 L16.5,11.5 Z M20.5,8.5 L19,8.5 L19,9.5 L20.5,9.5 L20.5,11 L19,11 L19,13 L17.5,13 L17.5,7 L20.5,7 L20.5,8.5 Z M9,9.5 L10,9.5 L10,8.5 L9,8.5 L9,9.5 Z M4,6 L2,6 L2,20 C2,21.1 2.9,22 4,22 L18,22 L18,20 L4,20 L4,6 Z M14,11.5 L15,11.5 L15,8.5 L14,8.5 L14,11.5 Z"
              id="Shape"
              fill="#4A90E2"
              fill-rule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  downarrow: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Admin-account"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Admin-Dashboard" transform="translate(-342.000000, -270.000000)">
          <g id="Group-10" transform="translate(324.000000, 166.000000)">
            <g
              id="arrow_drop_up-24px"
              transform="translate(18.000000, 104.000000)"
            >
              <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
              <path
                d="M8.71,12.29 L11.3,9.7 C11.69,9.31 12.32,9.31 12.71,9.7 L15.3,12.29 C15.93,12.92 15.48,14 14.59,14 L9.41,14 C8.52,14 8.08,12.92 8.71,12.29 Z"
                id="Path"
                fill="#417505"
                fill-rule="nonzero"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  close: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
    >
      <g>
        <g>
          <path
            fill="#17468f"
            d="M0 13C0 5.82 5.82 0 13 0s13 5.82 13 13-5.82 13-13 13S0 20.18 0 13z"
          />
        </g>
        <g>
          <path
            fill="#fff"
            d="M13.825 13.36L17.784 9.4a.357.357 0 1 0-.505-.504l-3.958 3.958-3.959-3.958a.357.357 0 1 0-.504.504l3.958 3.959-3.958 3.958a.357.357 0 1 0 .504.505l3.959-3.959 3.958 3.959a.356.356 0 0 0 .505 0 .357.357 0 0 0 0-.505z"
          />
          <path
            fill="none"
            stroke="#fff"
            stroke-miterlimit="20"
            d="M13.825 13.36v0L17.784 9.4a.357.357 0 1 0-.505-.504l-3.958 3.958v0L9.362 8.897a.357.357 0 1 0-.504.504l3.958 3.959v0l-3.958 3.958a.357.357 0 1 0 .504.505l3.959-3.959v0l3.958 3.959a.356.356 0 0 0 .505 0 .357.357 0 0 0 0-.505z"
          />
        </g>
      </g>
    </svg>
  ),
  closeBlack: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Gym-Admin"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          id="Reserving-Class"
          transform="translate(-1170.000000, -150.000000)"
        >
          <g id="Classes-Table" transform="translate(222.000000, 130.000000)">
            <g
              id="highlight_off-24px"
              transform="translate(948.000000, 20.000000)"
            >
              <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
              <path
                d="M13.89,8.7 L12,10.59 L10.11,8.7 C9.72,8.31 9.09,8.31 8.7,8.7 C8.31,9.09 8.31,9.72 8.7,10.11 L10.59,12 L8.7,13.89 C8.31,14.28 8.31,14.91 8.7,15.3 C9.09,15.69 9.72,15.69 10.11,15.3 L12,13.41 L13.89,15.3 C14.28,15.69 14.91,15.69 15.3,15.3 C15.69,14.91 15.69,14.28 15.3,13.89 L13.41,12 L15.3,10.11 C15.69,9.72 15.69,9.09 15.3,8.7 C14.91,8.32 14.27,8.32 13.89,8.7 Z M12,2 C6.47,2 2,6.47 2,12 C2,17.53 6.47,22 12,22 C17.53,22 22,17.53 22,12 C22,6.47 17.53,2 12,2 Z M12,20 C7.59,20 4,16.41 4,12 C4,7.59 7.59,4 12,4 C16.41,4 20,7.59 20,12 C20,16.41 16.41,20 12,20 Z"
                id="Shape"
                fill="#000000"
                fill-rule="nonzero"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  signout: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Admin-account"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
        opacity="1"
      >
        <g id="Admin-Dashboard" transform="translate(-32.000000, -1682.000000)">
          <g id="Side-Menu" transform="translate(0.000000, 70.000000)">
            <g id="Sign-Out" transform="translate(0.000000, 1601.000000)">
              <g
                id="power_settings_new-24px"
                transform="translate(32.000000, 11.000000)"
              >
                <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                <path
                  d="M12,3 C11.45,3 11,3.45 11,4 L11,12 C11,12.55 11.45,13 12,13 C12.55,13 13,12.55 13,12 L13,4 C13,3.45 12.55,3 12,3 Z M17.14,5.86 C16.75,6.25 16.76,6.86 17.13,7.25 C18.26,8.45 18.96,10.05 19,11.82 C19.09,15.65 15.92,18.95 12.09,18.99 C8.18,19.05 5,15.9 5,12 C5,10.16 5.71,8.49 6.87,7.24 C7.24,6.85 7.24,6.24 6.86,5.86 C6.46,5.46 5.81,5.47 5.43,5.88 C3.98,7.42 3.07,9.47 3,11.74 C2.86,16.62 6.83,20.84 11.71,20.99 C16.81,21.15 21,17.06 21,11.99 C21,9.62 20.08,7.48 18.58,5.88 C18.2,5.47 17.54,5.46 17.14,5.86 L17.14,5.86 Z"
                  id="Shape"
                  fill="#000000"
                  fill-rule="nonzero"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  members: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Gym-Admin"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
        opacity="0.5"
      >
        <g id="Gym-Info" transform="translate(-32.000000, -515.000000)">
          <g id="Side-Menu" transform="translate(0.000000, 70.000000)">
            <g id="Users" transform="translate(0.000000, 434.000000)">
              <g
                id="assignment_ind-24px"
                transform="translate(32.000000, 11.000000)"
              >
                <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                <path
                  d="M19,3 L14.82,3 C14.4,1.84 13.3,1 12,1 C10.7,1 9.6,1.84 9.18,3 L5,3 C3.9,3 3,3.9 3,5 L3,19 C3,20.1 3.9,21 5,21 L19,21 C20.1,21 21,20.1 21,19 L21,5 C21,3.9 20.1,3 19,3 Z M12,2.75 C12.22,2.75 12.41,2.85 12.55,3 C12.67,3.13 12.75,3.31 12.75,3.5 C12.75,3.91 12.41,4.25 12,4.25 C11.59,4.25 11.25,3.91 11.25,3.5 C11.25,3.31 11.33,3.13 11.45,3 C11.59,2.85 11.78,2.75 12,2.75 Z M19,19 L5,19 L5,5 L19,5 L19,19 Z M12,6 C10.35,6 9,7.35 9,9 C9,10.65 10.35,12 12,12 C13.65,12 15,10.65 15,9 C15,7.35 13.65,6 12,6 Z M12,10 C11.45,10 11,9.55 11,9 C11,8.45 11.45,8 12,8 C12.55,8 13,8.45 13,9 C13,9.55 12.55,10 12,10 Z M6,16.47 L6,18 L18,18 L18,16.47 C18,13.97 14.03,12.89 12,12.89 C9.97,12.89 6,13.96 6,16.47 Z M8.31,16 C9,15.44 10.69,14.88 12,14.88 C13.31,14.88 15.01,15.44 15.69,16 L8.31,16 Z"
                  id="Shape"
                  fill="#000000"
                  fill-rule="nonzero"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  appointment: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Gym-Admin"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
        opacity="0.5"
      >
        <g id="Gym-Info" transform="translate(-32.000000, -677.000000)">
          <g id="Side-Menu" transform="translate(0.000000, 70.000000)">
            <g id="Appointments" transform="translate(0.000000, 596.000000)">
              <g id="event-24px" transform="translate(32.000000, 11.000000)">
                <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                <path
                  d="M16,13 L13,13 C12.45,13 12,13.45 12,14 L12,17 C12,17.55 12.45,18 13,18 L16,18 C16.55,18 17,17.55 17,17 L17,14 C17,13.45 16.55,13 16,13 Z M16,3 L16,4 L8,4 L8,3 C8,2.45 7.55,2 7,2 C6.45,2 6,2.45 6,3 L6,4 L5,4 C3.89,4 3.01,4.9 3.01,6 L3,20 C3,21.1 3.89,22 5,22 L19,22 C20.1,22 21,21.1 21,20 L21,6 C21,4.9 20.1,4 19,4 L18,4 L18,3 C18,2.45 17.55,2 17,2 C16.45,2 16,2.45 16,3 Z M18,20 L6,20 C5.45,20 5,19.55 5,19 L5,9 L19,9 L19,19 C19,19.55 18.55,20 18,20 Z"
                  id="Shape"
                  fill="#000000"
                  fill-rule="nonzero"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  voice: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 14a3 3 0 0 0 3-3V6a3 3 0 0 0-6 0v5a3 3 0 0 0 3 3zm5-3a5 5 0 0 1-10 0H5a7 7 0 0 0 6 6.71V21h2v-3.29A7 7 0 0 0 19 11h-2z"
        fill="#000000"
      />
    </svg>
  ),
  court: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path
          fill="#000000"
          d="M120.8 55L87.58 199h18.52l29.1-126h18.2l-20.6 126h18.3l10.1-62H247v62h18v-62h85.8l10.1 62h18.3L358.6 73h18.2l29.1 126h18.5L391.2 55H120.8zm50.9 18h168.6l7.6 46H164.1l7.6-46zM73 217v30h366v-30H73zm-.64 48L20.69 489H491.3l-51.7-224h-18.5l47.6 206h-45L390 265h-18.3l14.2 87H265v-87h-18v87H126.1l14.2-87H122L88.35 471H43.31l47.56-206H72.36zm50.74 105h265.8l16.5 101H106.6l16.5-101z"
        ></path>
      </g>
    </svg>
  ),
  wod: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Gym-Admin"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
        opacity="0.5"
      >
        <g id="Gym-Info" transform="translate(-32.000000, -569.000000)">
          <g id="Side-Menu" transform="translate(0.000000, 70.000000)">
            <g id="Users" transform="translate(0.000000, 488.000000)">
              <g id="Kettlebell" transform="translate(32.000000, 11.000000)">
                <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
                <path
                  d="M18.6467511,4.05704946 C18.512155,3.80927466 18.3434329,3.58064608 18.1450361,3.37702024 C17.9464273,3.17316915 17.6583705,2.94251333 17.4046515,2.79474945 C14.1701053,1.66985182 9.74941767,1.82009345 6.7535412,2.73866224 C6.50512127,2.88484938 6.03520065,3.1792509 5.84337468,3.38084949 C5.65133675,3.58267333 5.48791375,3.80949991 5.35331763,4.05704946 C4.81535707,5.04747294 4.89463101,6.32982019 5.57121497,7.57522648 L7.22876088,10.6260101 C6.14245362,11.8540721 5.47667974,13.5089826 5.47667974,15.3276497 C5.47667974,18.5629129 7.58400986,21.2753713 10.4194308,22 L13.4498571,22 C16.285702,21.2753713 18.3928201,18.5629129 18.3928201,15.3276497 C18.3928201,13.5544831 17.7601124,11.9360631 16.7210728,10.7181373 L18.4288538,7.57522648 C19.1052258,6.32982019 19.1847117,5.04747294 18.6467511,4.05704946 Z M16.1701243,7.20280683 C15.9922309,7.51858458 15.7845057,7.8869171 15.5620841,8.281527 C15.4311317,8.51375616 15.2951343,8.75496904 15.156724,9 C14.2058386,8.46726541 13.1143495,8.16428945 11.9539842,8.16428945 C10.8350762,8.16428945 9.78087672,8.44615367 8.85433931,8.94385175 C8.72689654,8.71813579 8.60186664,8.49601331 8.48078504,8.28175159 C8.25836342,7.88714169 8.0506383,7.51880918 7.87252552,7.20280683 C7.4840554,6.44952191 6.70207011,5.64907247 7.11905582,4.74149216 C7.32765835,4.36776941 7.99075555,4.26018936 8.42594737,4.22425448 C8.42594737,4.22425448 8.71570966,4.162716 9.43276714,4.11375473 C11.589862,3.96642172 13.6412299,3.91319318 16.0483846,4.26108774 C16.2047817,4.31431628 16.5555235,4.42122254 16.7117012,4.52790422 C17.441481,5.43548452 16.6075096,6.39606878 16.1701243,7.20280683 Z"
                  id="Shape"
                  fill="#000000"
                  fill-rule="nonzero"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  done: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Gym-Admin"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Add-trainer-2" transform="translate(-320.000000, -967.000000)">
          <g id="Group-7" transform="translate(222.000000, 15.000000)">
            <g id="done-24px" transform="translate(98.000000, 952.000000)">
              <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
              <path
                d="M9,16.2 L5.5,12.7 C5.11,12.31 4.49,12.31 4.1,12.7 C3.71,13.09 3.71,13.71 4.1,14.1 L8.29,18.29 C8.68,18.68 9.31,18.68 9.7,18.29 L20.3,7.7 C20.69,7.31 20.69,6.69 20.3,6.3 C19.91,5.91 19.29,5.91 18.9,6.3 L9,16.2 Z"
                id="Path"
                fill="#4D4467"
                fill-rule="nonzero"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  edit: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Gym-Admin"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="User-Info" transform="translate(-402.000000, -897.000000)">
          <g id="Group-2" transform="translate(348.000000, 780.000000)">
            <g id="Group" transform="translate(42.000000, 109.000000)">
              <g id="create-24px" transform="translate(12.000000, 8.000000)">
                <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                <path
                  d="M3,17.46 L3,20.5 C3,20.78 3.22,21 3.5,21 L6.54,21 C6.67,21 6.8,20.95 6.89,20.85 L17.81,9.94 L14.06,6.19 L3.15,17.1 C3.05,17.2 3,17.32 3,17.46 Z M20.71,7.04 C21.1,6.65 21.1,6.02 20.71,5.63 L18.37,3.29 C17.98,2.9 17.35,2.9 16.96,3.29 L15.13,5.12 L18.88,8.87 L20.71,7.04 Z"
                  id="Shape"
                  fill="#4D4467"
                  fill-rule="nonzero"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  delete: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Gym-Admin"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          id="Gym-Admin-Packages"
          transform="translate(-520.000000, -920.000000)"
        >
          <g id="Group-16-Copy-2" transform="translate(348.000000, 803.000000)">
            <g id="Group-3" transform="translate(160.000000, 109.000000)">
              <g id="delete-24px" transform="translate(12.000000, 8.000000)">
                <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                <path
                  d="M6,19 C6,20.1 6.9,21 8,21 L16,21 C17.1,21 18,20.1 18,19 L18,9 C18,7.9 17.1,7 16,7 L8,7 C6.9,7 6,7.9 6,9 L6,19 Z M18,4 L15.5,4 L14.79,3.29 C14.61,3.11 14.35,3 14.09,3 L9.91,3 C9.65,3 9.39,3.11 9.21,3.29 L8.5,4 L6,4 C5.45,4 5,4.45 5,5 C5,5.55 5.45,6 6,6 L18,6 C18.55,6 19,5.55 19,5 C19,4.45 18.55,4 18,4 Z"
                  id="Shape"
                  fill="#D0021B"
                  fill-rule="nonzero"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  package: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Gym-Admin"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
        opacity="0.5"
      >
        <g id="Gym-Info" transform="translate(-32.000000, -623.000000)">
          <g id="Side-Menu" transform="translate(0.000000, 70.000000)">
            <g id="Packages" transform="translate(0.000000, 542.000000)">
              <g id="style-24px" transform="translate(32.000000, 11.000000)">
                <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                <path
                  d="M2.53,19.65 L3.87,20.21 L3.87,11.18 L1.44,17.04 C1.03,18.06 1.52,19.23 2.53,19.65 L2.53,19.65 Z M22.03,15.95 L17.07,3.98 C16.76,3.23 16.03,2.77 15.26,2.75 C15,2.75 14.73,2.79 14.47,2.9 L7.1,5.95 C6.35,6.26 5.89,6.98 5.87,7.75 C5.86,8.02 5.91,8.29 6.02,8.55 L10.98,20.52 C11.29,21.28 12.03,21.74 12.81,21.75 C13.07,21.75 13.33,21.7 13.58,21.6 L20.94,18.55 C21.96,18.13 22.45,16.96 22.03,15.95 L22.03,15.95 Z M12.83,19.75 L7.87,7.79 L15.22,4.75 L15.23,4.75 L20.18,16.7 L12.83,19.75 Z"
                  id="Shape"
                  fill="#000000"
                  fill-rule="nonzero"
                ></path>
                <circle
                  id="Oval"
                  fill="#000000"
                  fill-rule="nonzero"
                  cx="11"
                  cy="9"
                  r="1"
                ></circle>
                <path
                  d="M5.88,19.75 C5.88,20.85 6.78,21.75 7.88,21.75 L9.33,21.75 L5.88,13.41 L5.88,19.75 Z"
                  id="Path"
                  fill="#000000"
                  fill-rule="nonzero"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  reserve: (
    <svg
      height="24"
      viewBox="-51 -21 682 682.66669"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m313.585938 137.730469h-18.75v-18.75h18.75zm-31.25 0h-18.75v-18.75h18.75zm0 0" />
      <path d="m560.097656 621.25h-543.015625v-408.40625h-18.75v427.15625h580.515625v-427.15625h-18.75zm0 0" />
      <path d="m164.054688 137.730469 15.25-15.253907v-107.226562l-15.25-15.25h-41.648438l-15.253906 15.25v107.226562l15.253906 15.253907zm-38.152344-114.714844 4.265625-4.265625h26.121093l4.265626 4.265625v91.695313l-4.265626 4.269531h-26.121093l-4.265625-4.269531zm0 0" />
      <path d="m454.773438 137.730469 15.253906-15.253907v-107.226562l-15.253906-15.25h-41.648438l-15.25 15.25v107.226562l15.25 15.253907zm-38.148438-114.714844 4.265625-4.265625h26.121094l4.265625 4.265625v91.695313l-4.265625 4.269531h-26.121094l-4.265625-4.269531zm0 0" />
      <path d="m485.652344 59.488281v18.75h74.445312v100.230469h-543.015625v-100.230469h74.445313v-18.75h-93.195313v137.730469h580.515625v-137.730469zm0 0" />
      <path d="m194.929688 59.488281h187.320312v18.75h-187.320312zm0 0" />
      <path d="m398.945312 247.609375-155.714843 155.710937-64.996094-64.996093-75.355469 75.355469 140.347656 140.347656 231.070313-231.0625zm-269.546874 166.070313 48.835937-48.835938 64.996094 64.996094 155.714843-155.714844 48.835938 48.839844-204.550781 204.550781zm0 0" />
    </svg>
  ),
  sale: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>EDA54CCE-FE5F-43FB-9796-690EA7436BA2@1.5x</title>
      <g
        id="Gym-Admin"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Members" transform="translate(-44.000000, -503.000000)">
          <g id="Group-25" transform="translate(32.000000, 308.000000)">
            <g id="Users" transform="translate(0.000000, 184.000000)">
              <g
                id="monetization_on-24px"
                transform="translate(12.000000, 11.000000)"
              >
                <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                <path
                  d="M12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 C17.52,22 22,17.52 22,12 C22,6.48 17.52,2 12,2 Z M12,20 C7.59,20 4,16.41 4,12 C4,7.59 7.59,4 12,4 C16.41,4 20,7.59 20,12 C20,16.41 16.41,20 12,20 Z M12.31,11.14 C10.54,10.69 9.97,10.2 9.97,9.47 C9.97,8.63 10.76,8.04 12.07,8.04 C13.45,8.04 13.97,8.7 14.01,9.68 L15.72,9.68 C15.67,8.34 14.85,7.11 13.23,6.71 L13.23,5 L10.9,5 L10.9,6.69 C9.39,7.01 8.18,7.99 8.18,9.5 C8.18,11.29 9.67,12.19 11.84,12.71 C13.79,13.17 14.18,13.86 14.18,14.58 C14.18,15.11 13.79,15.97 12.08,15.97 C10.48,15.97 9.85,15.25 9.76,14.33 L8.04,14.33 C8.14,16.03 9.4,16.99 10.9,17.3 L10.9,19 L13.24,19 L13.24,17.33 C14.76,17.04 15.96,16.17 15.97,14.56 C15.96,12.36 14.07,11.6 12.31,11.14 L12.31,11.14 Z"
                  id="Shape"
                  fill="#000000"
                  fill-rule="nonzero"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  eye: (
    <svg
      id="eye"
      xmlns="http://www.w3.org/2000/svg"
      width="20.773"
      height="20.3"
      viewBox="0 0 29.773 20.3"
    >
      <g id="Group_5705" data-name="Group 5705" transform="translate(0 0)">
        <g id="Group_5704" data-name="Group 5704" transform="translate(0 0)">
          <path
            id="Path_1"
            data-name="Path 1"
            d="M174.727,170.667a4.06,4.06,0,1,0,4.06,4.06A4.063,4.063,0,0,0,174.727,170.667Z"
            transform="translate(-159.84 -164.577)"
            fill="#4D4467"
          />
          <path
            id="Path_2"
            data-name="Path 2"
            d="M14.887,74.667A16.006,16.006,0,0,0,0,84.817a15.992,15.992,0,0,0,29.773,0A16,16,0,0,0,14.887,74.667Zm0,16.917a6.767,6.767,0,1,1,6.767-6.767A6.769,6.769,0,0,1,14.887,91.584Z"
            transform="translate(0 -74.667)"
            fill="#4D4467"
          />
        </g>
      </g>
    </svg>
  ),
  download: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="feather feather-download"
    >
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
      <polyline points="7 10 12 15 17 10"></polyline>
      <line x1="12" y1="15" x2="12" y2="3"></line>
    </svg>
  ),
  downloadBarcode: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="feather feather-download"
    >
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
      <polyline points="7 10 12 15 17 10"></polyline>
      <line x1="12" y1="15" x2="12" y2="3"></line>
    </svg>
  ),
  attachment: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000"
      width="30px"
      height="20px"
      viewBox="0 0 24 24"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path d="M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z"></path>
      </g>
    </svg>
  ),
  attachment2: (
    <svg
      fill="#000000"
      viewBox="0 0 24 24"
      id="attachment-right"
      data-name="Flat Line"
      xmlns="http://www.w3.org/2000/svg"
      class="icon flat-line"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path
          id="primary"
          d="M10,6h5a6,6,0,0,1,6,6h0a6,6,0,0,1-6,6H7a4,4,0,0,1-4-4H3a4,4,0,0,1,4-4h8a2,2,0,0,1,2,2h0a2,2,0,0,1-2,2H7"
          style="fill: none; stroke: #000000; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2;"
        ></path>
      </g>
    </svg>
  ),

  refresh: (
    <svg
      width="25px"
      height="25px"
      viewBox="0 0 100 100"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>4. To refresh</title>
      <desc>Created with Sketch.</desc>
      <defs></defs>
      <g
        id="4.-To-refresh"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <g
          transform="translate(0.000000, 8.000000)"
          stroke="#222F3E"
          stroke-width="4"
        >
          <path
            d="M89,40 C89,17.90861 71.09139,0 49,0 C34.1239759,0 21.1446258,8.12062657 14.2530697,20.1707596"
            id="Layer-1"
          ></path>
          <polyline
            id="Layer-2"
            transform="translate(89.000000, 37.000000) scale(1, -1) rotate(11.000000) translate(-89.000000, -37.000000) "
            points="79 42 89 32 99 42"
          ></polyline>
          <path
            d="M91,84 C91,61.90861 73.09139,44 51,44 C36.1239759,44 23.1446258,52.1206266 16.2530697,64.1707596"
            id="Layer-3"
            transform="translate(51.000000, 64.000000) scale(-1, -1) translate(-51.000000, -64.000000) "
          ></path>
          <polyline
            id="Layer-4"
            transform="translate(11.000000, 47.000000) scale(-1, 1) rotate(11.000000) translate(-11.000000, -47.000000) "
            points="1 52 11 42 21 52"
          ></polyline>
        </g>
      </g>
    </svg>
  ),

  leftAttachment: (
    <svg
      viewBox="-8 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="25px"
      height="25px"
      transform="rotate(90)"
      fill="purple"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <title>attachment</title> <desc>Created with Sketch Beta.</desc>
        <g
          id="Page-1"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
        >
          <g
            id="Icon-Set-Filled"
            transform="translate(-214.000000, -153.000000)"
            fill="purple"
          >
            <path
              d="M228,157 L228,177 C228,180.313 225.313,183 222,183 C218.687,183 216,180.313 216,177 L216,159 C216,156.791 217.791,155 220,155 C222.209,155 224,156.791 224,159 L224,177 C224,178.104 223.104,179 222,179 C220.896,179 220,178.104 220,177 L220,161 L218,161 L218,177 C218,179.209 219.791,181 222,181 C224.209,181 226,179.209 226,177 L226,159 C226,155.687 223.313,153 220,153 C216.687,153 214,155.687 214,159 L214,178 C214.493,181.945 217.921,185 222,185 C226.079,185 229.507,181.945 230,178 L230,157 L228,157"
              id="attachment"
            >
              {" "}
            </path>{" "}
          </g>{" "}
        </g>{" "}
      </g>
    </svg>
  ),
  staff: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Gym-Admin"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Staff-Page" transform="translate(-32.000000, -569.000000)">
          <g id="Group-15" transform="translate(0.000000, 536.000000)">
            <g id="Gyms" transform="translate(0.000000, 22.000000)">
              <g
                id="people_outline_black_24dp"
                transform="translate(32.000000, 11.000000)"
              >
                <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                <path
                  d="M9,12 C10.93,12 12.5,10.43 12.5,8.5 C12.5,6.57 10.93,5 9,5 C7.07,5 5.5,6.57 5.5,8.5 C5.5,10.43 7.07,12 9,12 Z M9,7 C9.83,7 10.5,7.67 10.5,8.5 C10.5,9.33 9.83,10 9,10 C8.17,10 7.5,9.33 7.5,8.5 C7.5,7.67 8.17,7 9,7 Z M9,13.75 C6.66,13.75 2,14.92 2,17.25 L2,18 C2,18.55 2.45,19 3,19 L15,19 C15.55,19 16,18.55 16,18 L16,17.25 C16,14.92 11.34,13.75 9,13.75 Z M4.34,17 C5.18,16.42 7.21,15.75 9,15.75 C10.79,15.75 12.82,16.42 13.66,17 L4.34,17 Z M16.04,13.81 C17.2,14.65 18,15.77 18,17.25 L18,19 L21,19 C21.55,19 22,18.55 22,18 L22,17.25 C22,15.23 18.5,14.08 16.04,13.81 Z M15,12 C16.93,12 18.5,10.43 18.5,8.5 C18.5,6.57 16.93,5 15,5 C14.46,5 13.96,5.13 13.5,5.35 C14.13,6.24 14.5,7.33 14.5,8.5 C14.5,9.67 14.13,10.76 13.5,11.65 C13.96,11.87 14.46,12 15,12 Z"
                  id="Shape"
                  fill="#8700A9"
                  fill-rule="nonzero"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  subscription: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>87E7C48D-75FC-4E8C-9B53-1687B96A2BD4@1.5x</title>
      <g
        id="Gym-Admin"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Subscribed-users" transform="translate(-32.000000, -914.000000)">
          <g id="Dashboard" transform="translate(0.000000, 903.000000)">
            <g
              id="card_membership-24px"
              transform="translate(32.000000, 11.000000)"
            >
              <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
              <path
                d="M20,2 L4,2 C2.89,2 2,2.89 2,4 L2,15 C2,16.11 2.89,17 4,17 L8,17 L8,22 L12,20 L16,22 L16,17 L20,17 C21.11,17 22,16.11 22,15 L22,4 C22,2.89 21.11,2 20,2 Z M20,15 L4,15 L4,13 L20,13 L20,15 Z M20,10 L4,10 L4,4 L20,4 L20,10 Z"
                id="Shape"
                fill="#8700A9"
                fill-rule="nonzero"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  appointments: (
    <svg
      width="20"
      height="17"
      viewBox="0 0 20 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.5 2.25C3.5 1.2875 4.2875 0.5 5.25 0.5C6.2125 0.5 7 1.2875 7 2.25C7 3.2125 6.2125 4 5.25 4C4.2875 4 3.5 3.2125 3.5 2.25ZM11.375 16.25C10.885 16.25 10.4825 15.865 10.4563 15.375L10.0625 7.5L7 6.625H1.75C1.26875 6.625 0.875 6.23125 0.875 5.75C0.875 5.26875 1.26875 4.875 1.75 4.875H6.125L11.6025 0.96375C11.97 0.70125 12.4775 0.7625 12.775 1.10375C13.1075 1.4975 13.0375 2.08375 12.6175 2.38125L9.7475 4.4375H12.25L18.4538 0.85875C18.8125 0.64875 19.2675 0.7275 19.5387 1.0425C19.8538 1.41875 19.8013 1.97875 19.4163 2.27625L12.6875 7.5L12.2937 15.375C12.2675 15.865 11.865 16.25 11.375 16.25Z"
        fill="#64748B"
      />
    </svg>
  ),
  program: (
    <svg
      version="1.1"
      id="Icons"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="24px"
      height="24px"
      fill="#999999"
      stroke="#999999"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path
          className="st0"
          d="M26.6,21.1l-3.5-1.2L27,4.2c0,0,0,0,0,0c1.1-0.7,2-1.6,2.8-2.6c0.3-0.4,0.2-1.1-0.2-1.4c-0.4-0.3-1.1-0.2-1.4,0.2 C26.5,2.7,23.8,4,21,4c-0.6,0-1,0.4-1,1s0.4,1,1,1c1.2,0,2.5-0.2,3.6-0.6l-3.5,13.9l-7.2-2.5c0-0.1,0-0.1,0-0.2L10.6,10H12 c0.6,0,1-0.4,1-1s-0.4-1-1-1H8.8c-1.6,0-3-0.6-4.1-1.7c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4C4.7,9.1,6.5,9.9,8.4,10l2.9,5.9 c-2.1-0.5-4.3-0.1-6.1,1.2c-2,1.5-3.2,3.7-3.2,6.2C2,27.6,5.4,31,9.7,31h15.3c2.8,0,5.1-2.3,5.1-5.1C30,23.7,28.6,21.8,26.6,21.1z M20,25h-2.1c-0.4,1.7-2,3-3.9,3c-2.2,0-4-1.8-4-4s1.8-4,4-4c1.9,0,3.4,1.3,3.9,3H20c0.6,0,1,0.4,1,1S20.6,25,20,25z"
        ></path>
      </g>
    </svg>
  ),
  product: (
    <svg
      width="30px"
      height="30px"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="none"
        d="M4 6v12h16.001L20 6H4zm4 10H6V8h2v8zm2 0H9V8h1v8zm2 0h-1V8h1v8zm4 0h-3V8h3v8zm2 0h-1V8h1v8z"
      />
      {/* <path
        d="M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zM4 18V6h16l.001 12H4z"
        fill={"red"}
      />
      <path
        d="M6 8h2v8H6zm3 0h1v8H9zm8 0h1v8h-1zm-4 0h3v8h-3zm-2 0h1v8h-1z"
        fill={"red"}
      /> */}
    </svg>
  ),
  followupProgram: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 16 16"><path fill="currentColor" d="M15.5 11a.5.5 0 0 1 .5.5a2.5 2.5 0 0 1-2.336 2.495L13.5 14H9.707l1.147 1.146a.5.5 0 0 1 .057.638l-.057.07a.5.5 0 0 1-.638.057l-.07-.057l-2-2a.5.5 0 0 1-.057-.638l.057-.07l2-2a.5.5 0 0 1 .765.638l-.057.07L9.707 13H13.5a1.5 1.5 0 0 0 1.5-1.5a.5.5 0 0 1 .5-.5M6 0a6 6 0 0 1 5.917 7H10.9A5 5 0 1 0 7 10.9v1.017A6 6 0 1 1 6 0m7.784 6.089l.07.057l2 2a.5.5 0 0 1 .057.638l-.057.07l-2 2a.5.5 0 0 1-.765-.638l.057-.07L14.293 9H10.5A1.5 1.5 0 0 0 9 10.5a.5.5 0 1 1-1 0a2.5 2.5 0 0 1 2.336-2.495L10.5 8l3.793-.001l-1.147-1.145a.5.5 0 0 1-.057-.638l.057-.07a.5.5 0 0 1 .638-.057M6.5 2a.5.5 0 0 1 .492.41L7 2.5v4a.5.5 0 0 1-.41.492L6.5 7h-3a.5.5 0 0 1-.09-.992L3.5 6H6V2.5a.5.5 0 0 1 .41-.492z"/></svg>
  ),
  gate: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      viewBox="0 0 512 512"
    >
      <path
        fill="#000000"
        d="M99.73 57L25 131.7V487h110V188.3l80-80V57H99.73zM80 103h80v18H80v-18zm138 27.7L154.7 194c6.4 3.2 13.6 5 21.3 5 26.1 0 47-20.9 47-47 0-7.7-1.8-14.9-5-21.3zm22.7 15.3c.2 2 .3 4 .3 6 0 8.5-1.7 16.6-4.6 24H473c5.8 0 8.9-1.8 11.3-4.5 2.3-2.6 3.7-6.5 3.7-10.5s-1.4-7.9-3.7-10.5c-2.4-2.7-5.5-4.5-11.3-4.5H240.7zm-15.2 48c-4 4.8-8.7 8.9-13.9 12.3l216.8 117.9c5 2.7 8.7 2.6 12 1.4 3.4-1.2 6.5-4 8.4-7.5 1.9-3.5 2.5-7.5 1.7-11-.8-3.4-2.7-6.5-7.7-9.3L251.7 194h-26.2zm-35 21.3c-4.2 1-8.5 1.6-12.9 1.7l86.7 211.6c2.2 5.3 5.1 7.5 8.5 8.7 3.3 1.1 7.5.9 11.2-.6 3.7-1.5 6.7-4.2 8.3-7.4 1.5-3.2 2-6.8-.1-12.1l-77.4-188.6-24.3-13.3z"
      />
    </svg>
  ),
  scanner: (
    <svg
      fill="#000000"
      width="30px"
      height="30px"
      viewBox="0 0 56 56"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path d="M 47.6171 21.4023 C 48.8591 21.4023 49.5157 20.7227 49.5157 19.4805 L 49.5157 13.7383 C 49.5157 8.9102 47.0780 6.4961 42.1562 6.4961 L 36.4374 6.4961 C 35.1952 6.4961 34.5155 7.1758 34.5155 8.3711 C 34.5155 9.5898 35.1952 10.2696 36.4374 10.2696 L 42.1093 10.2696 C 44.4062 10.2696 45.7421 11.5118 45.7421 13.9492 L 45.7421 19.4805 C 45.7421 20.7227 46.4218 21.4023 47.6171 21.4023 Z M 8.3827 21.4023 C 9.6015 21.4023 10.2577 20.7227 10.2577 19.4805 L 10.2577 13.9492 C 10.2577 11.5118 11.5702 10.2696 13.9140 10.2696 L 19.5858 10.2696 C 20.8046 10.2696 21.4843 9.5898 21.4843 8.3711 C 21.4843 7.1758 20.8046 6.4961 19.5858 6.4961 L 13.8436 6.4961 C 8.9687 6.4961 6.4843 8.9102 6.4843 13.7383 L 6.4843 19.4805 C 6.4843 20.7227 7.1640 21.4023 8.3827 21.4023 Z M 17.6405 36.9649 L 19.2108 36.9649 L 19.2108 19.0352 L 17.6405 19.0352 Z M 21.2030 36.9649 L 24.1796 36.9649 L 24.1796 19.0352 L 21.2030 19.0352 Z M 25.5155 36.9649 L 27.3905 36.9649 L 27.3905 19.0352 L 25.5155 19.0352 Z M 29.0546 36.9649 L 31.9608 36.9649 L 31.9608 19.0352 L 29.0546 19.0352 Z M 33.1562 36.9649 L 35.4530 36.9649 L 35.4530 19.0352 L 33.1562 19.0352 Z M 36.2968 36.9649 L 37.7733 36.9649 L 37.7733 19.0352 L 36.2968 19.0352 Z M 13.8436 49.5039 L 19.5858 49.5039 C 20.8046 49.5039 21.4843 48.8242 21.4843 47.6289 C 21.4843 46.4102 20.8046 45.7305 19.5858 45.7305 L 13.9140 45.7305 C 11.5702 45.7305 10.2577 44.4883 10.2577 42.0508 L 10.2577 36.5196 C 10.2577 35.2774 9.5780 34.5977 8.3827 34.5977 C 7.1405 34.5977 6.4843 35.2774 6.4843 36.5196 L 6.4843 42.2383 C 6.4843 47.0898 8.9687 49.5039 13.8436 49.5039 Z M 36.4374 49.5039 L 42.1562 49.5039 C 47.0780 49.5039 49.5157 47.0664 49.5157 42.2383 L 49.5157 36.5196 C 49.5157 35.2774 48.8360 34.5977 47.6171 34.5977 C 46.3984 34.5977 45.7421 35.2774 45.7421 36.5196 L 45.7421 42.0508 C 45.7421 44.4883 44.4062 45.7305 42.1093 45.7305 L 36.4374 45.7305 C 35.1952 45.7305 34.5155 46.4102 34.5155 47.6289 C 34.5155 48.8242 35.1952 49.5039 36.4374 49.5039 Z"></path>
      </g>
    </svg>
  ),
  img: (
    <svg
      class="w-6 h-6 text-gray-800 dark:text-white"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        fill-rule="evenodd"
        d="M13 10a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H14a1 1 0 0 1-1-1Z"
        clipRule="evenodd"
      />
      <path
        fill-rule="evenodd"
        d="M2 6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12c0 .556-.227 1.06-.593 1.422A.999.999 0 0 1 20.5 20H4a2.002 2.002 0 0 1-2-2V6Zm6.892 12 3.833-5.356-3.99-4.322a1 1 0 0 0-1.549.097L4 12.879V6h16v9.95l-3.257-3.619a1 1 0 0 0-1.557.088L11.2 18H8.892Z"
        clipRule="evenodd"
      />
    </svg>
  ),
  deactivate: (
    <svg
      width="24.773"
      height="24.3"
      viewBox="0 0 32 32"
      enable-background="new 0 0 32 32"
      id="Editable-line"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      fill="#4D4467"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d=" M16,7C9.934,7,4.798,10.776,3,16c1.798,5.224,6.934,9,13,9s11.202-3.776,13-9C27.202,10.776,22.066,7,16,7z"
          fill="none"
          id="XMLID_13_"
          stroke="#4D4467"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
        ></path>
        <circle
          cx="16"
          cy="16"
          fill="none"
          id="XMLID_14_"
          r="5"
          stroke="#4D4467"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
        ></circle>
        <line
          fill="none"
          id="XMLID_15_"
          stroke="#4D4467"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
          x1="3"
          x2="29"
          y1="3"
          y2="29"
        ></line>
      </g>
    </svg>
  ),
  workshop: (
    <svg
      width="20"
      height="17"
      viewBox="0 0 20 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 6.5H3V4.5H4.5V6.5H7V4.5H8.5V6.5H11.5V4.5H13V6.5H15.5V4.5H17V6.5H18.5V8H17V10H15.5V8H13V10H11.5V8H8.5V10H7V8H4.5V10H3V8H1.5V6.5ZM10.25 1.5C10.25 0.947715 10.6977 0.5 11.25 0.5C11.8023 0.5 12.25 0.947715 12.25 1.5C12.25 2.05228 11.8023 2.5 11.25 2.5C10.6977 2.5 10.25 2.05228 10.25 1.5ZM10.5 13.5C10.5 12.9477 10.9477 12.5 11.5 12.5C12.0523 12.5 12.5 12.9477 12.5 13.5C12.5 14.0523 12.0523 14.5 11.5 14.5C10.9477 14.5 10.5 14.0523 10.5 13.5ZM14.25 13C14.25 11.067 12.683 9.5 10.75 9.5C8.817 9.5 7.25 11.067 7.25 13C7.25 14.933 8.817 16.5 10.75 16.5C12.683 16.5 14.25 14.933 14.25 13Z"
        fill="#64748B"
      />
    </svg>
  ),
  upload: (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.5 7.37187C10.6167 7.37187 10.726 7.3901 10.8281 7.42656C10.9302 7.46302 11.025 7.525 11.1125 7.6125L14.2625 10.7625C14.4375 10.9375 14.5214 11.1417 14.5141 11.375C14.5068 11.6083 14.4229 11.8125 14.2625 11.9875C14.0875 12.1625 13.8797 12.2536 13.6391 12.2609C13.3984 12.2682 13.1906 12.1844 13.0156 12.0094L11.375 10.3688V16.625C11.375 16.8729 11.2911 17.0807 11.1234 17.2484C10.9557 17.4161 10.7479 17.5 10.5 17.5C10.2521 17.5 10.0443 17.4161 9.87656 17.2484C9.70885 17.0807 9.625 16.8729 9.625 16.625V10.3688L7.98438 12.0094C7.80937 12.1844 7.60156 12.2682 7.36094 12.2609C7.12031 12.2536 6.9125 12.1625 6.7375 11.9875C6.57708 11.8125 6.49323 11.6083 6.48594 11.375C6.47865 11.1417 6.5625 10.9375 6.7375 10.7625L9.8875 7.6125C9.975 7.525 10.0698 7.46302 10.1719 7.42656C10.274 7.3901 10.3833 7.37187 10.5 7.37187ZM15.75 3.5C16.2313 3.5 16.6432 3.67135 16.9859 4.01406C17.3286 4.35677 17.5 4.76875 17.5 5.25V7C17.5 7.24792 17.4161 7.45573 17.2484 7.62344C17.0807 7.79115 16.8729 7.875 16.625 7.875C16.3771 7.875 16.1693 7.79115 16.0016 7.62344C15.8339 7.45573 15.75 7.24792 15.75 7V5.25L5.25 5.25V7C5.25 7.24792 5.16615 7.45573 4.99844 7.62344C4.83073 7.79115 4.62292 7.875 4.375 7.875C4.12708 7.875 3.91927 7.79115 3.75156 7.62344C3.58385 7.45573 3.5 7.24792 3.5 7V5.25C3.5 4.76875 3.67135 4.35677 4.01406 4.01406C4.35677 3.67135 4.76875 3.5 5.25 3.5L15.75 3.5Z" fill="white"/>
    </svg>
  ),
};

export const ComonIcons = comonIcons;
